// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__N1+WB","header":"Modal_header__Py3e0","title":"Modal_title__YWDWh","body":"Modal_body__Y+IDt"};